module.exports = __webpack_public_path__ + "img/bg2.2f76b3b9.jpg";